import { useParams } from 'react-router';
import OAuthRedirectScreen from '@sdk/login/screens/OAuthRedirectScreen';
import { OauthProvider } from '@sdk/login/oauth/types';

import config from '../config';

const OauthRoute: React.FC = () => {
  const { provider } = useParams();

  const goToApp = (): void => {
    window.location.href = `${config.KIOSK_APP_URL}/setup`;
  };

  return (
    <OAuthRedirectScreen provider={(provider as unknown) as OauthProvider} goToApp={goToApp} />
  );
};

export default OauthRoute;
